import type {FC, ReactNode} from 'react';
import {memo} from 'react';

import MainMenuLayout from '../MainMenuLayout/MainMenuLayout';
import NotificationTopContainer from '../NotificationTopContainer/NotificationTopContainer';
import TopMenuLayout from '../TopMenuLayout/TopMenuLayout';

interface Props {
  children: ReactNode;
  customMainClass?: string;
  isWithCrumbs?: boolean;
  isWithFrom?: boolean;
  withTopMenu?: boolean;
}

const MainContainerWithMenuColor: FC<Props> = ({
  children,
  customMainClass = '',
  isWithCrumbs,
  isWithFrom,
  withTopMenu = true,
}) => {
  return (
    <main className={`MainContainerWithMenuLayout ${customMainClass}`}>
      <NotificationTopContainer />

      <div className="container">
        <MainMenuLayout />
        {withTopMenu ? (
          <div className="offsetMenuContainer">
            <TopMenuLayout
              isWithCrumbs={isWithCrumbs}
              isWithFrom={isWithFrom}
            />
          </div>
        ) : null}
      </div>
      {children}
    </main>
  );
};

export default memo(MainContainerWithMenuColor);
